import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button } from '@/components/ui-kit/button';
import { LOGIN_COLORS } from '@/modules/auth/constants/login-theme';

export const EmailSentPage = () => {
  const { t } = useTranslation();
  return (
    <div className="flex w-full flex-col gap-8">
      <div className="flex justify-center">
        <svg
          className="h-14 w-14"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          aria-hidden="true"
          style={{ color: LOGIN_COLORS.primary }}
        >
          <circle cx="12" cy="12" r="10" fill="currentColor" />
          <path
            d="M8.6 12.4l2.1 2.1 4.9-5.4"
            stroke="#FFFFFF"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>
      </div>

      <div className="flex flex-col gap-3">
        <h2
          className="text-[2rem] font-bold leading-tight tracking-tight sm:text-[2.125rem]"
          style={{ color: LOGIN_COLORS.textPrimary }}
        >
          {t('EMAIL_SENT')}
        </h2>
        <p className="text-sm font-normal leading-5" style={{ color: LOGIN_COLORS.textMuted }}>
          {t('EMAIL_SENT_REGISTERED_EMAIL')}
        </p>
      </div>

      <Link to="/login" className="w-full">
        <Button
          className="h-12 w-full rounded-xl border-0 text-sm font-semibold shadow-none hover:opacity-90"
          size="lg"
          type="button"
          style={{ backgroundColor: LOGIN_COLORS.primary, color: LOGIN_COLORS.pureWhite }}
        >
          {t('GO_TO_LOGIN')}
        </Button>
      </Link>
      <Link to="/signup" className="w-full">
        <Button
          className="h-12 w-full rounded-xl border-0 text-sm font-semibold shadow-none"
          size="lg"
          type="submit"
          variant="ghost"
          style={{ color: LOGIN_COLORS.primary }}
        >
          {t('CHANGE_EMAIL_ADDRESS')}
        </Button>
      </Link>
    </div>
  );
};
